import styled, { keyframes } from "styled-components";
import Animate from "./Animate";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`;

const FadeUpWrap = styled(Animate)`
    & {
      opacity: 0;
    }

    &.fadeUp{
        animation:${fadeInUp} 0.5s forwards;
    }
`;

FadeUpWrap.defaultProps = {
    effectClassName: "fadeUp"
};

export default FadeUpWrap;